import { Outlet } from "react-router-dom"

const CustomerMasterLayout = () => {
    return <div className="container  bg-white py-0 px-0">
        <Outlet />
    </div>
}
export { CustomerMasterLayout }